/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import Joi from 'joi';

export const schema = Joi.object({
    currentEmail: Joi.string()
        .trim()
        .required()
        .label('Current Email'),
    newEmail: Joi.string()
        .trim()
        .email({ tlds: { allow: ['com', 'net'] } })
        .max(50)
        .required()
        .custom((value, helpers) => {
            const [{ currentEmail }] = helpers.state.ancestors;
            if (value === currentEmail) {
                return helpers.error('custom.emailMismatch', { message: 'New email must be different from the current email' });
            }
            return value;
        })
        .messages({
            'string.empty': 'New Email is required.',
            'string.max': 'New Email should not exceed {#limit} characters.',
            'string.email': 'Please enter a valid email address for New Email',
            'custom.emailMismatch': '{{#message}}',
        })
        .label('New Email'),
    confirmNewEmail: Joi.string()
        .trim()
        .email({ tlds: { allow: ['com', 'net'] } })
        .max(50)
        .required()
        .custom((value, helpers) => {
            const [{ newEmail }] = helpers.state.ancestors;
            if (value !== newEmail) {
                return helpers.error('custom.emailMismatch', { message: 'Confirm New Email should match with New Email' });
            }
            return value;
        })
        .messages({
            'string.empty': 'Confirm New Email is required.',
            'string.max': 'Confirm New Email should not exceed {#limit} characters.',
            'string.email': 'Please enter a valid email address for Confirm New Email',
            'custom.emailMismatch': '{{#message}}',
        })
        .label('Confirm New Email'),
});


export const desktopSchema = Joi.object({
    currentEmail: Joi.string()
        .trim()
        .required()
        .label('Current Email'),
    newEmail: Joi.string()
        .trim()
        .email({ tlds: { allow: ['com', 'net'] } })
        .max(50)
        .required()
        .custom((value, helpers) => {
            const [{ currentEmail }] = helpers.state.ancestors;
            if (value === currentEmail) {
                return helpers.error('custom.emailMismatch', { message: 'New email must be different from the current email' });
            }
            return value;
        })
        .messages({
            'string.empty': 'New Email is required.',
            'string.max': 'New Email should not exceed {#limit} characters.',
            'string.email': 'Please enter a valid email address for New Email',
            'custom.emailMismatch': '{{#message}}',
        })
        .label('New Email'),
});